import {
  BaSeButton,
  BaSeHeading6,
  BaSeParagraph,
  BaSeTextArea,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useMessage } from '../../../../hooks/messages/useMessage';
import { useInterviewService } from '../../../../hooks/services/interview-service';

function FormJustificativa({ closeModal, id, setShowNotas }) {
  const [justificativa, setJustificativa] = React.useState('');
  const { pendingInterview } = useInterviewService();

  const { handleError, handleSuccess } = useMessage();

  const isValid = React.useCallback(() => {
    return justificativa.trim().length === 0;
  }, [justificativa]);

  const validate = React.useCallback(() => {
    if (isValid()) {
      handleError('Campo obrigatório não informado.');
      return false;
    }
    return true;
  }, [isValid, handleError]);

  const handleRequestValdiate = React.useCallback(async () => {
    if (!validate()) return;

    const dto = {
      idInterview: id,
      justification: justificativa,
      option: 'SOLICITAR_REVISAO',
    };
    try {
      await pendingInterview(dto);
      await setShowNotas((prev) => !prev);
      handleSuccess('Operação realizada com sucesso!');
      closeModal();
    } catch (error) {
      handleError('Erro ao tentar solicitar aprovação!');
    }
  }, [
    handleError,
    closeModal,
    id,
    setShowNotas,
    justificativa,
    pendingInterview,
    handleSuccess,
    validate,
  ]);

  return (
    <div style={{ display: 'grid', gap: 8 }}>
      <BaSeHeading6
        color={BaSeTheme.colors.feedbackInterface.atencao55}
        isBold={true}
      >
        Atenção!
      </BaSeHeading6>
      <BaSeParagraph>
        Tem certeza que deseja solicitar a revisão da entrevista desse
        candidato?
      </BaSeParagraph>

      <BaSeParagraph>
        Ao solicitar a revisão, a justificativa deverá ser informada:
      </BaSeParagraph>

      <BaSeTextArea
        hasCounter="chars"
        label="Justificativa"
        maxLength={200}
        onChange={setJustificativa}
        textSize="medium"
        value={justificativa}
      />
      <div>
        <div style={{ display: 'flex', gap: 8 }}>
          <BaSeButton
            color={BaSeTheme.colors.defaultColors.black}
            value="Não"
            onClick={() => closeModal()}
          />
          <BaSeButton
            color={BaSeTheme.colors.defaultColors.black}
            value="Solicitar revisão"
            type="secondary"
            onClick={() => handleRequestValdiate()}
          />
        </div>
      </div>
    </div>
  );
}

export default FormJustificativa;
